var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", [_vm._v("Maps")]),
      _c(
        "v-expansion-panel-content",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticStyle: { "justify-items": "flex-end" },
                  attrs: { cols: "12" },
                },
                [
                  _c("v-switch", {
                    attrs: {
                      "hide-details": "",
                      color: "orange darken-3",
                      label: "Exclude mode",
                    },
                    model: {
                      value: _vm.model.mapsExclude,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "mapsExclude", $$v)
                      },
                      expression: "model.mapsExclude",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            _vm._l(_vm.maps, function (map) {
              return _c(
                "v-col",
                { key: `ikm${map}`, attrs: { cols: "12", md: "2", sm: "2" } },
                [
                  _c("v-checkbox", {
                    attrs: { value: map, label: `${map}` },
                    model: {
                      value: _vm.model.maps,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "maps", $$v)
                      },
                      expression: "model.maps",
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }